<div class="login-panel overflow">
  <div class="section-ctnr">
    <div class="section1">
      <div class="left">
        <img id="bg" src="./assets/images/home/login-bg-img.png"/>
        <img
          id="logo"
          src="./assets/images/home/logo-yep.png"
          (click)="toYepIo()"
        />
      </div>
      <div class="right">
        <div class="login-panel">
          <mat-tab-group class="mat-group" mat-align-tabs="center" animationDuration="0ms"
                         (selectedTabChange)="selectChange($event)">
            <mat-tab
              label="Developer">
              <div class="login-info"
                   *ngIf="!isSignUpDeveloper">
                <div class="login-title">Sign in</div>
                <!--                <div class="login-content">-->
                <!--                  Don’t have an account?-->
                <!--                  <span class="login-link"-->
                <!--                        (click)="contactUs()">-->
                <!--                    Contact us-->
                <!--                  </span>-->
                <!--                  to get your-->
                <!--                  <span class="login-link"-->
                <!--                        (click)="toDemo()">free trial</span-->
                <!--                  >-->
                <!--                </div>-->
              </div>
              <div class="login-info"
                   fxLayout="column"
                   fxLayoutAlign="start start"
                   fxLayoutGap="8px"
                   *ngIf="isSignUpDeveloper">
                <div class="login-title">Create your account</div>
                <div class="login-info__description">
                  List your project for free. No credit card required.
                </div>
              </div>
              <form
                *ngIf="!isSignUpDeveloper"
                [formGroup]="form"
                ngStyle.lt-sm="width: 100%"
                (ngSubmit)="login()"
              >
                <div class="form-control">
                  <label
                    [ngStyle]="{
                      color:
                        submitted && f.email.errors
                          ? 'red'
                          : 'rgba(222, 222, 222, 0.4)'
                    }"
                  >Email Address*</label
                  >
                  <input
                    type="text"
                    matInput
                    formControlName="email"
                    required
                  />
                </div>
                <div class="form-control">
                  <label
                    [ngStyle]="{
                      color:
                        submitted && f.password.errors
                          ? 'red'
                          : 'rgba(222, 222, 222, 0.4)'
                    }"
                  >Password*</label
                  >
                  <input
                    type="password"
                    matInput
                    formControlName="password"
                    required
                  />
                </div>
                <div
                  style="
                    margin-bottom: 30px;
                    text-align: left;
                    font-size: 16px;
                    color: #ff0000;
                  "
                >
                  <ng-container *ngIf="isDeactivated"
                  >User is deactivated
                  </ng-container
                  >
                  <ng-container *ngIf="isEmailOrPasswordIncorrect"
                  >You entered an invalid Login Name and/or Password
                    combination.
                  </ng-container
                  >
                  <ng-container *ngIf="noCompany"
                  >User doesn't have a company
                  </ng-container
                  >
                  <ng-container *ngIf="notAuthorized"
                  >User is not authorized to login
                  </ng-container
                  >
                </div>
                <div class="text-1">
                  <div>If you have forgotten your password please contact your administrator.</div>
                </div>
                <div class="form-control btn-container">
                  <button
                    [disabled]="isLoading"
                    [ngStyle]="{'background' : isLoading ? 'grey': '#2142FF'}"
                    class="mobile-btn">
                    Sign in
                    <!--                    <ng-container *ngIf="!isLoading">-->
                    <!--                      &lt;!&ndash; <mat-icon style="font-size: 16px; height: 16px; width: 16px; margin-right: 5px">lock</mat-icon> &ndash;&gt;-->
                    <!--                      Sign in-->
                    <!--                    </ng-container>-->
                    <!--                    <div-->
                    <!--                      *ngIf="isLoading"-->
                    <!--                      style="height: 36px; display: flex; align-items: center"-->
                    <!--                    >-->
                    <!--                      <mat-spinner-->
                    <!--                        diameter="20"-->
                    <!--                        class="custom-spinner"-->
                    <!--                        style="height: 20px; width: 20px"-->
                    <!--                      ></mat-spinner>-->
                    <!--                    </div>-->
                  </button>
                </div>
              </form>
              <form
                *ngIf="isSignUpDeveloper"
                [formGroup]="signUpDeveloperForm"
                ngStyle.lt-sm="width: 100%"
                (ngSubmit)="login()"
              >
                <div class="form-control">
                  <label
                    [ngStyle]="{
                      color:
                        submitted && f.email.errors
                          ? 'red'
                          : 'rgba(222, 222, 222, 0.4)'
                    }"
                  >Email Address*</label
                  >
                  <input
                    type="text"
                    matInput
                    formControlName="email"
                    required
                  />
                </div>
                <div class="form-control">
                  <label
                    [ngStyle]="{
                      color:
                        submitted && f.password.errors
                          ? 'red'
                          : 'rgba(222, 222, 222, 0.4)'
                    }"
                  >Password*</label
                  >
                  <input
                    type="password"
                    matInput
                    formControlName="password"
                    required
                  />
                </div>
                <div
                  style="
                    margin-bottom: 30px;
                    text-align: left;
                    font-size: 16px;
                    color: #ff0000;
                  "
                >
                  <ng-container *ngIf="isDeactivated"
                  >User is deactivated
                  </ng-container
                  >
                  <ng-container *ngIf="isEmailOrPasswordIncorrect"
                  >You entered an invalid Login Name and/or Password
                    combination.
                  </ng-container
                  >
                  <ng-container *ngIf="noCompany"
                  >User doesn't have a company
                  </ng-container
                  >
                  <ng-container *ngIf="notAuthorized"
                  >User is not authorized to login
                  </ng-container
                  >
                </div>
                <div class="form-control btn-container">
                  <button
                    (click)="onCreateAccount()"
                    [disabled]="isLoading"
                    [ngStyle]="{'background' : isLoading ? 'grey': '#2142FF'}"
                    class="mobile-btn">
                    Create free account
                    <!--                    <ng-container *ngIf="!isLoading">-->
                    <!--                      &lt;!&ndash; <mat-icon style="font-size: 16px; height: 16px; width: 16px; margin-right: 5px">lock</mat-icon> &ndash;&gt;-->
                    <!--                      Sign in-->
                    <!--                    </ng-container>-->
                    <!--                    <div-->
                    <!--                      *ngIf="isLoading"-->
                    <!--                      style="height: 36px; display: flex; align-items: center"-->
                    <!--                    >-->
                    <!--                      <mat-spinner-->
                    <!--                        diameter="20"-->
                    <!--                        class="custom-spinner"-->
                    <!--                        style="height: 20px; width: 20px"-->
                    <!--                      ></mat-spinner>-->
                    <!--                    </div>-->
                  </button>
                </div>
              </form>
              <div class="account-block"
                   fxLayout="row"
                   fxLayoutAlign="start center"
                   fxLayoutGap="4px"
                   *ngIf="!isSignUpDeveloper">
                <div class="account-block__text">
                  Don't have an account?
                </div>
                <div class="account-block__signup"
                     (click)="isSignUpDeveloper = true">
                  Sign Up
                </div>
              </div>
              <div class="aaa"
                   fxLayout="column"
                   fxLayoutGap="8px">
                <div class="account-block"
                     style="color: white"
                     fxLayout="row"
                     fxLayoutAlign="start center"
                     fxLayoutGap="4px"
                     *ngIf="isSignUpDeveloper">
                  <div class="account-block__text">
                    By signing up, I accept
                  </div>
                  <a class="account-block__signup"
                     [href]="customerUrl + 'terms'"
                     target="_blank">
                    T&C
                  </a>
                  <div class="account-block__text">and</div>
                  <a class="account-block__signup"
                     [href]="customerUrl + 'privacy'"
                     target="_blank">
                    Privacy Policy.
                  </a>
                </div>
                <div class="account-block"
                     fxLayout="row"
                     fxLayoutAlign="start center"
                     fxLayoutGap="4px"
                     *ngIf="isSignUpDeveloper">
                  <div class="account-block__text">
                    Already have an account?
                  </div>
                  <div class="account-block__signup"
                       (click)="isSignUpDeveloper = false">
                    Sign in
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Agent">
              <div class="login-info">
                <div class="login-title">Sign in</div>
                <!--                <div class="login-content">-->
                <!--                  Don’t have an account?-->
                <!--                  <span class="login-link"-->
                <!--                        (click)="contactUs()">-->
                <!--                    Contact us-->
                <!--                  </span>-->
                <!--                  to get your-->
                <!--                  <span class="login-link"-->
                <!--                        (click)="toDemo()">free trial</span-->
                <!--                  >-->
                <!--                </div>-->
              </div>
              <form
                [formGroup]="form"
                ngStyle.lt-sm="width: 100%"
                (ngSubmit)="login()"
              >
                <div class="form-control">
                  <label
                    [ngStyle]="{
                      color:
                        submitted && f.email.errors
                          ? 'red'
                          : 'rgba(222, 222, 222, 0.4)'
                    }"
                  >Email Address*</label
                  >
                  <input
                    type="text"
                    matInput
                    formControlName="email"
                    required
                  />
                </div>
                <div class="form-control">
                  <label
                    [ngStyle]="{
                      color:
                        submitted && f.password.errors
                          ? 'red'
                          : 'rgba(222, 222, 222, 0.4)'
                    }"
                  >Password*</label
                  >
                  <input
                    type="password"
                    matInput
                    formControlName="password"
                    required
                  />
                </div>
                <div
                  style="
                    margin-bottom: 30px;
                    text-align: left;
                    font-size: 16px;
                    color: #ff0000;
                  "
                >
                  <ng-container *ngIf="isDeactivated"
                  >User is deactivated
                  </ng-container
                  >
                  <ng-container *ngIf="isEmailOrPasswordIncorrect"
                  >You entered an invalid Login Name and/or Password
                    combination.
                  </ng-container
                  >
                  <ng-container *ngIf="noCompany"
                  >User doesn't have a company
                  </ng-container
                  >
                  <ng-container *ngIf="notAuthorized"
                  >User is not authorized to login
                  </ng-container
                  >
                </div>
                <div>
                  <div>If you have forgotten your password please contact your administrator.</div>
                </div>
                <div class="form-control btn-container">
                  <button
                    [ngClass]="{ deactivated: isLoading }"
                    [disabled]="isLoading"
                    class="mobile-btn"
                  >
                    <ng-container *ngIf="!isLoading">
                      <!-- <mat-icon style="font-size: 16px; height: 16px; width: 16px; margin-right: 5px">lock</mat-icon> -->
                      Sign in
                    </ng-container>
                    <div
                      *ngIf="isLoading"
                      style="height: 36px; display: flex; align-items: center"
                    >
                      <mat-spinner
                        diameter="20"
                        class="custom-spinner"
                        style="height: 20px; width: 20px"
                      ></mat-spinner>
                    </div>
                  </button>
                </div>
              </form>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
  <app-home-map></app-home-map>
  <app-new-footer></app-new-footer>
</div>
